export default "__VITE_ASSET__4ebb4173__"